// Lib
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { get } from 'lodash/fp';

// Components
import RouteModalRootAuthenticated from '../../../components/modal/RouteModalRootAuthenticated';

// Styles
import './PlanModal.scss';

const PlanModal = (props) => {
    const { children, route } = props;
    const className = route && route.className;
    const hideBack = get(['query', 'no_back'], props.location);

    return (
        <RouteModalRootAuthenticated
            {...props}
            showBack={!hideBack}
            className={classNames('PlanModal auto-width', className)}
        >
            {children}
        </RouteModalRootAuthenticated>
    );
};

PlanModal.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    route: PropTypes.object,
    location: PropTypes.object,
};

export default PlanModal;
